import { questionModuleQuery, useModule } from 'system/structure-modules';

export default function SpaceEditScreen() {
    const { EditQuestionScreen } = useModule(questionModuleQuery);
    return <EditQuestionScreen />;
}
